import React from 'react';

interface SuccessStatusProps {
  message?: string;
}

export default function SuccessStatus({
  message = "Login successful!"
}: SuccessStatusProps) {
  return (
    <div>
      <i
        className="fa fa-check-circle"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#28a745' }}
      />
      <h2 style={{ marginBottom: '1rem', color: '#28a745' }}>{message}</h2>
      <p style={{ color: '#666' }}>
        You're being redirected to your dashboard...
      </p>
    </div>
  );
}